// extracted by mini-css-extract-plugin
export default {"sortIcon":"Table_sortIcon__4MI29","pages":"Table_pages__k-NVo","pageBtn":"Table_pageBtn__7vJrT"};